module.exports = __webpack_public_path__ + "static/3d-69a3d1e6976969a3c6441c90fdc42365.jpg";